export enum PASSWORD_PATTERN {
  atLeastOneDigit = '(?=.*[0-9])',
  atLeastOneLowercase = '(?=.*[a-z])',
  atLeastOneUppercase = '(?=.*[A-Z])',
  atLeastOneSpecial = '(?=.*[!@#$%()+-/-&;:=|\'"_?><*~,.])',
}
